import {
  animate,
  AnimationTriggerMetadata,
  sequence,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const UnderlineAnimation: AnimationTriggerMetadata =
    trigger('underlineAnimation', [
      transition('void => *', [
        style({
          transform: 'scale(0, 1)',
          opacity: 0,
        }),
        sequence([
          animate('.15s ease-out', style({
            transform: 'scale(1, 1)',
            opacity: 1,
          })),
        ]),
      ]),
      transition('* => void', [
        style({
          opacity: 1,
        }),
        sequence([
          animate('.15s ease-out', style({
            transform: 'scale(0, 1)',
            opacity: 0,
          })),
        ]),
      ]),
    ]);
